/* eslint-disable no-undef */
/* eslint-disable consistent-return */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useRef, useState } from "react";

const DurationRenderer = (props: any) => {
  const [duration, setDuration] = useState<string>("00:00:00");
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!props.value) return;

    const startTime = new Date(props.data.time).getTime();

    const updateDuration = () => {
      const totalSeconds = Math.floor(
        (new Date(props.value).getTime() - startTime) / 1000
      );

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const formattedTime = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      setDuration(formattedTime);
    };

    const countDuration = () => {
      const totalSeconds = Math.floor(
        (new Date().getTime() - startTime) / 1000
      );

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const formattedTime = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      setDuration(formattedTime);
    };

    if (props.data.state === "TALKING") {
      updateDuration();
      // Clear any existing interval before starting a new one
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      // Start a new interval and store its ID in the ref
      intervalRef.current = setInterval(countDuration, 1000);
    } else {
      // If not talking, calculate the final duration and stop the interval
      updateDuration();
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    // Cleanup function to clear the interval when the component unmounts
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [props, props.value, props.data.state, props.data.time]);

  return <span>{duration}</span>;
};

export default DurationRenderer;
